module.exports = __webpack_public_path__ + "img/thailand.5fd4b8d5.png";